export default __webpack_public_path__ + "sharp-sans-bold-italic-d68f42eb8425e812eb5c52ab791d6e90.bundle.woff2";